import {
  IsBoolean,
  IsDefined,
  IsInt,
  IsISO8601,
  IsNumber,
  IsOptional,
  IsString,
  Length, Matches
} from 'class-validator';
import { BaseDto } from '../base.dto';
import { Exclude } from 'class-transformer';
import { CostCentreBriefDto } from '../cost-centre-brief.dto';
import { UserBriefDto } from '../user-brief.dto';
import { EmployeeBriefDto } from '../employee-brief.dto';
import { CurrencyDto } from '../currency.dto';
import { validationPatterns } from '../../constants';
import { BankingSafeDto } from '../banking-safe';
import { MerchantBriefDto } from '../merchant-brief.dto';

export class BankingLodgementDto extends BaseDto {
  @IsDefined()
  @IsInt()
  costCentreId: number;

  @IsDefined()
  @IsInt()
  merchantId: number;

  @IsDefined()
  @IsInt()
  currencyId: number;

  @IsDefined()
  @IsInt()
  preparedByUserId: number;

  @IsOptional()
  @IsInt()
  preparedByEmployeeId: number;

  @IsDefined()
  @IsString()
  @IsISO8601()
  dayPrepared: string;

  @IsDefined()
  @IsBoolean()
  isCollected: boolean;

  @IsOptional()
  @IsString()
  @IsISO8601()
  dayCollected?: string;

  @IsDefined()
  @IsNumber({maxDecimalPlaces: 2})
  amount: number;

  @IsOptional()
  @IsString()
  @Length(1, 45)
  slipNo?: string;

  @IsDefined()
  @IsString()
  @Length(1, 45)
  bagNo: string;

  @IsDefined()
  @IsString()
  @Length(1, 45)
  witnessedBy: string;

  @IsOptional()
  @Exclude()
  costCentre?: CostCentreBriefDto;

  @IsOptional()
  @Exclude()
  bankingSafe?: BankingSafeDto;

  @IsOptional()
  @Exclude()
  merchant?: MerchantBriefDto;

  @IsOptional()
  @Exclude()
  preparedByUser?: UserBriefDto;

  @IsOptional()
  @Exclude()
  preparedByEmployee?: EmployeeBriefDto;

  @IsOptional()
  @Exclude()
  currency?: CurrencyDto;

  @IsDefined()
  @IsInt()
  bankingSafeId: number;

  @IsOptional()
  @Length(0, 255)
  @Matches(validationPatterns.noteValidation)
  note?: string;
}
